import { DialogActions as RMWCDialogActions } from "@rmwc/dialog"
import { styled, StyleProps } from "../../styles"

export const DialogActions = styled(RMWCDialogActions)((props: StyleProps) => ({
  padding: props.theme.spacing(0, 7, 6),
  justifyContent: `space-between`,
}))
